export default function Sass_Intro() {
  return (
    <div>
      <h1>Sass Intro</h1>
    </div>
  );
}
